module.exports = __webpack_public_path__ + "img/isotipo_producto_azul.ad4aa6ac.png";